import { ArrowUpRightIcon } from '@heroicons/react/24/outline';
import { FC, useState } from 'react';

import { Dialog, DialogPanel, DialogTitle } from 'primitives/Dialog';

const JointAccreditationDetailsDialogText: FC = () => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <>
      <div
        className="w-full text-indigo-600 text-sm flex space-x-1 items-center cursor-pointer"
        onClick={() => setOpen(true)}
      >
        <span>Joint Accreditation is permitted</span>
        <span>
          <ArrowUpRightIcon className="w-4 h-4" />
        </span>
      </div>
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <DialogPanel className="min-w-[720px]">
          <DialogTitle>Joint Accreditation</DialogTitle>
          <p className="text-sm text-gray-700 my-3">
            <strong>Joint accreditation is permitted.</strong> You can now opt for Joint
            accreditation.
          </p>
          <div className="space-y-3">
            <div className="bg-white p-3 rounded border-l-2 border-blue-400">
              <p className="text-sm font-medium text-gray-900 mb-1">With Spouse:</p>
              <p className="text-sm text-gray-700">
                Eligibility is based on the combined annual income and/or net worth of the applicant
                and their spouse.
              </p>
            </div>
            <div className="bg-white p-3 rounded border-l-2 border-blue-400">
              <p className="text-sm font-medium text-gray-900 mb-1">With Parents/Children:</p>
              <p className="text-sm text-gray-700">
                The individual applicant's eligibility is assessed, and a joint accreditation
                certificate may be issued accordingly.
              </p>
            </div>
          </div>
        </DialogPanel>
      </Dialog>
    </>
  );
};

export default JointAccreditationDetailsDialogText;
